<template>
    <div class="cont">
      <div class="hearbg">
        <div class="hear">
          <div>
              <img :src="imgurl(infor.companyLogoImg)" width="198" height="60">
          </div>
          <div class="nav">
              <router-link to="/home">首页</router-link>
              <router-link to="/huoyunxx">货源信息</router-link>
              <router-link to="/cheyuanxx">车源信息</router-link>
              <router-link to="/chelgz">车辆跟踪</router-link>
              <router-link to="/huowgz">货物跟踪</router-link>
<!--               <router-link to="/appdownload">注册用户</router-link>-->
              <router-link to="/news">新闻资讯</router-link>
          </div>
          <div class="longbtn">
            <router-link to="/appdownload">注册</router-link>
            <a v-if="isShow" target="_blank" :href="url" class="actv">登录</a>
            <a v-else target="_blank" :href="grzxUrl" class="actv">个人中心</a>
          </div>
      </div>
      </div>
        <router-view />
        <div class="footerbg">
          <div class="footer">
            <div class="lxiwom">
              <div class="jiarwm">
                <!--                  <div style="margin-right:50px">-->
                <!--                    <div style="margin-bottom:40px;font-size:16px;">加入我们</div>-->
                <!--                    <div style="margin-bottom:30px">-->
                <!--                      <router-link to="/xxx">社会招聘</router-link>-->
                <!--                    </div>-->
                <!--                    <div>-->
                <!--                      <router-link to="/xxx">校园招聘</router-link>-->
                <!--                    </div>-->
                <!--                  </div>-->
                <div style="margin:30px;font-size: 16px;">
                  <router-link to="/aboutus">了解我们</router-link>
                </div>
                <div>
                  <!--                    <div style="margin-bottom:40px;font-size:16px;">关于我们</div>-->

                  <div style="margin:30px;font-size: 16px;">
                    <router-link to="/contactus">联系我们</router-link>
                  </div>
                </div>
              </div>
              <div class="hotline">
                <div style="margin-right:15px;">
                  <img :src="imgurl(infor.officialAccountCode)" width="130" height="130" />
                  <div style="margin-top:15px;">关注平台官网微信</div>
                </div>
                <div>
                  <div style="margin-bottom:20px;font-size:16px;">欢迎拨打热线</div>
                  <div style="margin-bottom:10px;font-size:20px;">{{infor.basicTelephone}}</div>
                  <div>周一至周五9:00-21:00</div>
                </div>
              </div>
            </div>
            <div class="beianh">
              <div>备案号【{{infor.basicRecordNum}}】</div>
              <div>Copyright © 2022 kunya. All Rights Reserved.河北诚泰供应链管理有限公司版权所有</div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import mymixins from '@/mixins'
import { mapActions } from 'vuex'
import { gethomeInfor } from '@/utils/service'
import { loginurl,wtUrl } from '@/utils/confing'
export default {
  name: 'app',
  mixins:[mymixins],
  components: {},
  data() {
    return {
      infor:{},
      url:loginurl,
      grzxUrl:wtUrl,
      isShow:true
    }
  },
  methods: {
    //??
    handleOpen() {

    },
    handleClose() {

    },
    ...mapActions({
      getwzxx:'getwzxx'
    })
  },
  created(){
      //获取首页相关信息
      gethomeInfor().then(data => {
          this.infor = data
          this.getwzxx(data)
      })
  },
  computed: {

  },
  mounted(){
    this.$nextTick(() => {
      setInterval(() => {
        if(localStorage.jlcyUserLogon){
          this.isShow = false
        }else{
          this.isShow = true
        }
      },1000)
    })
  },
  filters:{
    toUpper(value) {
      value == value.toString().replace(/(^\s+)|(\s+$)/,'')
      if(!value){
        return ''
      }
      return value.toUpperCase()
    }
  }
}
</script>

<style lang="stylus" scoped>
    a
      text-decoration:none
      color: #fff
    .router-link-active
      padding-bottom: 6px
      border-bottom: 1px #fff solid
    .cont
      font-size: 14px
      font-family: Roboto, 'Segoe UI',Arial,'Microsoft Yahei',sans-serif
      .hearbg
        background: #085998
        .hear
          width: 1400px
          box-sizing: border-box
          display:-webkit-box
          display: -webkit-flex
          display: flex
          align-items: center
          margin: 0 auto
          padding: 20px 0
          color: #fff
          .nav
            margin:0 60px 0 150px
            a
              margin-right: 50px
          .longbtn
            display:-webkit-box
            display: -webkit-flex
            display: flex
            a
              box-sizing: border-box
              display: block
              width: 110px
              height: 40px
              line-height: 40px
              color: #08599A
              background: #fff
              text-align: center
              cursor pointer
            .actv
              color: #fff
              background: #08599A
              border:1px solid #fff
   .footerbg
      color: #fff
      background: #085998
      padding-top:50px
      .footer
        width: 1200px
        margin: 0 auto
        box-sizing: border-box
        justify-content: space-between
        .lxiwom
          display:-webkit-box
          display: -webkit-flex
          display: flex
          justify-content: space-between
          border-bottom:1px solid #fff
          padding-bottom: 90px
          a
           text-decoration:none
          .jiarwm
            display:-webkit-box
            display: -webkit-flex
            display: flex
          .hotline
            display:-webkit-box
            display: -webkit-flex
            display: flex
        .beianh
          display:-webkit-box
          display: -webkit-flex
          display: flex
          padding: 20px 0
          justify-content: space-between
</style>
